import { render, staticRenderFns } from "./noseList.vue?vue&type=template&id=72ff6ef8&scoped=true&"
import script from "./noseList.vue?vue&type=script&lang=js&"
export * from "./noseList.vue?vue&type=script&lang=js&"
import style0 from "./noseList.vue?vue&type=style&index=0&id=72ff6ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff6ef8",
  null
  
)

export default component.exports